import React from 'react';

function Input({
  id,
  name,
  label,
  type = 'text',
  value,
  onChange,
  placeholder,
  required = false,
  autoFocus = false,
  autoComplete,
  min,
  step,
  disabled = false,
  hint,
  error,
}) {
  return (
    <div>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-slate-700 mb-2">
          {label}
        </label>
      )}
      <input
        id={id}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        autoFocus={autoFocus}
        autoComplete={autoComplete}
        min={min}
        step={step}
        disabled={disabled}
        className={`field-input ${error ? 'field-input-error' : ''} ${
          disabled ? 'opacity-60 cursor-not-allowed bg-slate-50' : ''
        }`}
      />
      {hint && !error && (
        <p className="mt-1.5 text-xs text-content-muted">{hint}</p>
      )}
      {error && (
        <p className="mt-1.5 text-xs text-red-600">{error}</p>
      )}
    </div>
  );
}

export default Input;
